import { render, staticRenderFns } from "./StartStep.vue?vue&type=template&id=537b1ddf&scoped=true"
import script from "./StartStep.vue?vue&type=script&lang=js"
export * from "./StartStep.vue?vue&type=script&lang=js"
import style0 from "./StartStep.vue?vue&type=style&index=0&id=537b1ddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b1ddf",
  null
  
)

export default component.exports